<template>
  <div class="mode-content">
    <b-overlay :show="gettingModes" rounded opacity="0.6" spinner-small>
      <b-form-input
        v-model="modeSelected"
        class="email-response__mode"
        list="modes"
        placeholder="Mode"
        aria-label="mode"
        autocomplete="off"
        @change="modeSelectedFunction()"
        :disabled="disabled"
        @stopSpinner="stopSpinner"
      ></b-form-input>
      <datalist id="modes">
        <option v-for="mode in modeList" :key="mode.id">
          {{ mode.name }}
        </option>
      </datalist>
    </b-overlay>
  </div>
</template>
<script>
export default {
  name: "ModeTable",
  props: {
    infoRow: Object,
    disabled: Boolean,
    infoMode: Object,
    index: Number
  },
  data() {
    return {
      modeList: null,
      modeSelected: null,
      gettingModes: true,
      haulInformation: null
    };
  },
  methods: {
    async modeSelectedFunction() {
      let infoMode = this.modeList.find(
        item => item.name === this.modeSelected
      );
      await this.getHaulInformation();
      for (let i in this.haulInformation) {
        let info = {};
        info.haulId = this.haulInformation[i].haul_id;
        info.payload = {};
        info.payload.tms_mode = {};
        info.payload.tms_mode.id = infoMode.id;
        info.payload.tms_mode.name = infoMode.name;
        await this.$store.dispatch("quotes/haul/updateHaul", info);
      }
    },
    stopSpinner() {
      this.gettingModes = false;
    },
    async getHaulInformation() {
      let response = await this.$store.dispatch(
        "quotes/quote/getHaulId",
        this.infoRow.id
      );
      this.haulInformation = response.data;
    }
  },
  async created() {
    if (this.infoMode) {
      this.modeSelected = this.infoMode.name;
      this.stopSpinner();
    }
    // La petición que llena el getter con los Modes hay que volverla a implementar en caso de necesitar este componente
    this.modeList = this.$store.getters["quotes/quote/showModeList"];
    this.stopSpinner();
  }
};
</script>

<style lang="scss" scoped>
.mode-content {
  width: 200%;
}
.email-response {
  &__mode {
    width: 100%;
  }
}
</style>
